
export enum AppEndPoint {
    Home='/document/sortis',
    function='/functions',
    category='/category',
    definition='/definition',
    Documents = '/document/list',
    BlockOrganization = 'organization-blocked',
    subscriptionError ='/subscription-with-error'
}
